import { viewDateTimeUtc } from "src/common/dateTime";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";

import { ZSysDataHistory } from "./ZSysData";

export const columnDisplayId: RtColumn<{ displayId: number }> = {
  key: "displayId",
  title: "Display ID",
  render: ({ displayId }) => displayId,
  width: 100,
  minWidth: 90,
};

export const sysColumnsHistory: RtColumn<ZSysDataHistory>[] = [
  {
    key: "createdAt",
    title: "Дата создания",
    minWidth: 120,
    width: 140,
    render: (row) => viewDateTimeUtc(row.createdAt),
  },
  {
    key: "updatedAt",
    title: "Дата последнего изменения",
    minWidth: 120,
    width: 140,
    render: (row) => viewDateTimeUtc(row.updatedAt),
  },
  {
    key: "createdBy",
    title: "Автор создания",
    minWidth: 140,
    width: 160,
    render: (row) => row.createdBy?.label,
  },
  {
    key: "updatedBy",
    title: "Автор последнего изменения",
    minWidth: 140,
    width: 160,
    render: (row) => row.updatedBy?.label,
  },
];
